// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ADmr","actionsCol":"EnrolledClinics_actionsCol__1OZIF"};